/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LoginResponse } from '../models/login-response';
import { postLogin } from '../fn/authentication/post-login';
import { PostLogin$Params } from '../fn/authentication/post-login';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postLogin()` */
  static readonly PostLoginPath = '/authentication/login';

  /**
   * Log in and c4l-addons permitted check.
   *
   * Wraps the login of c4l-basic and checks additionally if organization of user is permitted to use c4l-addons. It can be used for Frontend-Implementation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLogin$Response(params: PostLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginResponse>> {
    const obs = postLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Log in and c4l-addons permitted check.
   *
   * Wraps the login of c4l-basic and checks additionally if organization of user is permitted to use c4l-addons. It can be used for Frontend-Implementation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLogin(params: PostLogin$Params, context?: HttpContext): Observable<LoginResponse> {
    const resp = this.postLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LoginResponse>): LoginResponse => r.body)
    );
  }

}
